import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			margin: 0,
			backgroundColor: 'transparent',
			borderBottom: `1px solid ${theme.palette.getTextColors().primary}`,
			borderLeft: 'none',
			borderRight: 'none',
			boxShadow: 'none',

			'&:first-child': {
				borderTop: `1px solid ${theme.palette.getTextColors().primary}`,
			},
		},
		summary: {
			padding: 0,

			'& $summaryContent': {
				padding: 0,
				margin: theme.spacing(2, 0),
			},
		},
		summaryContent: {},
		focused: {
			backgroundColor: `transparent !important`,
		},

		expanded: {
			margin: '0 !important',
		},

		rounded: {
			borderRadius: '0 !important',
		},

		title: {
			margin: 0,
		},

		icon: {
			color: theme.palette.getTextColors().primary,
		},

		details: {
			padding: theme.spacing(0, 0, 2, 0),
		},
	}),
	{ name: 'FAQ-FAQ3-Item' },
)

export default useStyles
